import { __ } from '@wordpress/i18n';
import VerificationTab from './components/VerificationTab';
import './scss/tailwind.scss';
import { addFilter } from '@wordpress/hooks';

addFilter(
    'dokan-admin-vendor-tabs',
    'dokan-admin-vendor-verification-tab',
    function ( tabs = [] ) {
        tabs.push( {
            name: 'verification',
            title: __( 'Verification', 'dokan' ),
            component: VerificationTab,
            position: 3,
        } );
        return tabs;
    }
);
